import { Project } from '../types';

export const myProjects: Project[] = [
  {
    name: 'MPC-HC Remote Control beta',
    platform: 'android',
    description:
      'Remote control application for MPC-HC player utilizing its built-in web server API.',
    github: 'https://github.com/burdukowsky/mpc-hc-android',
    downloadLink:
      'https://github.com/burdukowsky/mpc-hc-android/raw/master/apk/release/mpc_hc_remote_control_beta.apk',
  },
  {
    name: 'cron-editor-ngx-translate',
    platform: 'npm',
    description:
      'An open-source cron-editor fork enhanced with ngx-translate for full i18n support.',
    link: 'https://www.npmjs.com/package/cron-editor-ngx-translate',
    github: 'https://github.com/burdukowsky/cron-editor-ngx-translate',
    demoLink: 'https://burdukowsky.github.io/cron-editor-ngx-translate/',
  },
  {
    name: 'Keenetic Policy Changer (Java)',
    platform: 'java',
    description:
      'A desktop Java utility to quickly change the policy for a specific device on a Keenetic router via Telnet.',
    github: 'https://github.com/burdukowsky/keenetic-policy-changer-java',
  },
  {
    name: 'Keenetic Policy Changer (Android)',
    platform: 'android',
    description:
      'Android app that allows managing active policies for devices connected to a Keenetic router.',
    github: 'https://github.com/burdukowsky/keenetic-policy-changer-android',
    downloadLink:
      'https://github.com/burdukowsky/keenetic-policy-changer-android/raw/master/apk/keenetic-policy-changer-1.0.apk',
  },
  {
    name: 'Copy Page URL',
    platform: 'extension',
    description:
      'Firefox extension that adds a toolbar icon to quickly copy the current web page URL.',
    link: 'https://addons.mozilla.org/en-US/firefox/addon/copy-web-page-url/',
    github: 'https://github.com/burdukowsky/copy-page-url-firefox-extension',
  },
  {
    name: 'My Calendar beta',
    platform: 'android',
    description: 'Yet another simple calendar application for Android.',
    github: 'https://github.com/burdukowsky/my-calendar',
    downloadLink:
      'https://github.com/burdukowsky/my-calendar/raw/master/apk/my-calendar-beta.apk',
  },
];
